import { render } from "./AdminCrudPage.vue?vue&type=template&id=ef84995e"
import script from "./AdminCrudPage.vue?vue&type=script&lang=js"
export * from "./AdminCrudPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__